import customerIdRegex from '@eneco/common/validation/customerIdRegex';
import * as yup from 'yup';


export const canRegisterCustomerIDSchema = yup.object({
  customerId: yup.string().required('customerIdRequired').matches(customerIdRegex, 'customerIdInvalid'),
});
